import { Center, Text } from '~/commonComponents';
import { shouldUseReferralProgramV2 } from '~/growthbook';

interface IInstructionItemProps {
  icon: string;
  title: string;
  description: string | React.ReactNode;
}

export const InstructionItem = ({ icon, title, description }: IInstructionItemProps) => {
  return (
    <Center>
      <img src={icon} style={{ width: 37, height: 37 }} alt="icon" />
      <Text bold fontSize={18} color="primary_500" paddingTop={14} textAlign="center">
        {title}
      </Text>
      <Text
        paddingTop={4}
        textAlign="center"
        color={shouldUseReferralProgramV2() ? 'neutral_500' : 'neutral_600'}
      >
        {description}
      </Text>
    </Center>
  );
};
